import '.h{display:grid;}.ssr-plugin'
import '.i{grid-template-columns:minmax(0, 1fr);}.ssr-plugin'
import '.j{gap:1.5rem;}.ssr-plugin'
import { PageLayout } from '@app/pages/layout/PageLayout'
import { Title } from '@app/components/core/typography/Title'
import { BlogCard } from '@app/components/blocks/card/BlogCard'
import { styled } from 'inlines'
import { pages } from '@app/util/links'
import useMediaQuery from '@app/util/useMediaQuery'
import { useTranslations } from '@i18n/useLanguage'
import { useTenantContext } from '@app/util/contexts/TenantContext'
import { Empty } from '@app/components/blocks/empty/Empty'

export const StoriesPage = () => {
  const t = useTranslations()
  const isMobile = useMediaQuery()
  const { tenant, loading } = useTenantContext()

  return (
    <PageLayout gap={0}>
      <Title.H1 style={{ textAlign: 'center' }}>
        {t.app.blogPage.tabs.stories}
      </Title.H1>

      <>
        {loading ? (
          <div>{t.app.blogPage.loading}</div>
        ) : tenant.stories.length === 0 && !loading ? (
          <Empty title={t.app.blogPage.noContent} />
        ) : (
          <styled.div className="h i j"
            style={{
              '@media (min-width: 800px)': {
                gridTemplateColumns: 'repeat(3, minmax(0, 1fr))',
                '& > :nth-child(1)': {
                  gridColumn: 'span 2',
                },
              },
            }}
          >
            {tenant.stories.map((item, index) => (
              <span key={item.id}>
                <BlogCard
                  orientation={
                    index === 0 && !isMobile ? 'horizontal' : 'vertical'
                  }
                  image={item.images?.[0]?.src}
                  meta={new Date(item.publishedAt).toLocaleDateString()}
                  title={item.title}
                  to={pages.blog('verhalen', item.slug)}
                  imageStyle={
                    index === 0 && !isMobile
                      ? {
                          aspectRatio: '1/1',
                          width: 'auto',
                          maxHeight: '25rem',
                        }
                      : undefined
                  }
                  intro={index === 0 && !isMobile ? item.intro : undefined}
                />
              </span>
            ))}
          </styled.div>
        )}
      </>
    </PageLayout>
  )
}
